import {EventEmitter, Injectable, TemplateRef} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import { SidebarPanelParams, LandingPageTile, PersistedTileSetup } from '../tiles/home-tile.model';
import {LocalStorageService, SessionStorageService} from 'angular-web-storage';
import {AbstractService} from '../abstract.service';

export interface ISidebarChange {
  panelId: string;
  params?: SidebarPanelParams;
}

@Injectable()
export class SidebarService extends AbstractService {
  /**
   * layer paint change stream
   * @type {Subject<any>}
   */
  private sidebar = new Subject<ISidebarChange>();
  /**
   * Observable for map paint changes
   * @type {Observable<any>}
   */
  public sidebarChanged$: Observable<ISidebarChange> = this.sidebar.asObservable();
  private requests = new Subject<{ panel: string, maximize: boolean }>();
  public requestStream$: Observable<{ panel: string, maximize: boolean }> = this.requests.asObservable();

  public titleChange: EventEmitter<{ panel: string, title: string, template: TemplateRef<void> }> = new EventEmitter();

  constructor(local: LocalStorageService, session: SessionStorageService) {
    super(local, session);
    this.name = 'SidebarService';
  }

  public requestSidebarPanel(panelId: string, params?: SidebarPanelParams) {
    this.sidebar.next({ panelId, params });
  }

  public savePanelSetup(panel: LandingPageTile) {
    super.setLocal(panel.panel, panel.getPersistedObject());
  }

  public removePanelSetup(panel: LandingPageTile) {
    super.removeLocal(panel.panel);
  }

  public loadPanelSetup(panel: string): PersistedTileSetup {
    return super.getLocal(panel);
  }

  public requestTileMaximize(panel: string, maximize: boolean): void {
    this.requests.next({panel: panel, maximize: maximize});
  }
}
